/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllFacilityServiceAreasResponse } from './FindAllFacilityServiceAreasResponse';
import {
    FindAllFacilityServiceAreasResponseFromJSON,
    FindAllFacilityServiceAreasResponseFromJSONTyped,
    FindAllFacilityServiceAreasResponseToJSON,
    FindAllFacilityServiceAreasResponseToJSONTyped,
} from './FindAllFacilityServiceAreasResponse';

/**
 * 
 * @export
 * @interface FindAllFacilityServiceAreas200Response
 */
export interface FindAllFacilityServiceAreas200Response {
    /**
     * 
     */
    data?: FindAllFacilityServiceAreasResponse;
}

/**
 * Check if a given object implements the FindAllFacilityServiceAreas200Response interface.
 */
export function instanceOfFindAllFacilityServiceAreas200Response(value: object): value is FindAllFacilityServiceAreas200Response {
    return true;
}

export function FindAllFacilityServiceAreas200ResponseFromJSON(json: any): FindAllFacilityServiceAreas200Response {
    return FindAllFacilityServiceAreas200ResponseFromJSONTyped(json, false);
}

export function FindAllFacilityServiceAreas200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllFacilityServiceAreas200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllFacilityServiceAreasResponseFromJSON(json['data']),
    };
}

export function FindAllFacilityServiceAreas200ResponseToJSON(json: any): FindAllFacilityServiceAreas200Response {
    return FindAllFacilityServiceAreas200ResponseToJSONTyped(json, false);
}

export function FindAllFacilityServiceAreas200ResponseToJSONTyped(value?: FindAllFacilityServiceAreas200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllFacilityServiceAreasResponseToJSON(value['data']),
    };
}

